const stats = [
  { value: "+25", label: "Años de experiencia", icon: "ri-award-line" },
  { value: "+1.200", label: "Clientes satisfechos", icon: "ri-group-line" },
  { value: "98%", label: "Tasa de satisfacción", icon: "ri-star-line" },
];

export default function StatsSection() {
  return (
    <section className="bg-[#6B7F5C] py-14">
      <div className="max-w-screen-xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 md:gap-8">
          {stats.map((stat, i) => (
            <div key={i} className="text-center flex flex-col items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full">
                <i className={`${stat.icon} text-white text-lg`} />
              </div>
              <p className="text-3xl md:text-4xl font-bold text-white" style={{ fontFamily: "'Playfair Display', serif" }}>
                {stat.value}
              </p>
              <p className="text-white/75 text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
